import { $api } from "@/shared/api";

// «Проверить снова»: загрузить друзей из Steam заново (`POST /api/friends/refresh`, 204).
// Результат приходит событием `friends.updated`, без него — опросом `useFriends`.
export const useRefreshFriends = () => $api.useMutation("post", "/api/friends/refresh");
